/** Enforcing theme tokens to be used for volkswagen */
const themeTokens = {
    primaryColor: '#001E50',
    hoveredPrimaryColor: '#0f2e5c',
    textColor: '#fff',

    baseFontSize: '0.875rem',
    buttonFontSize: '0.875rem',
    inputFontSize: '1rem',
};

export default themeTokens;
